import { createApp } from 'vue/dist/vue.esm-bundler'
import App from './App.vue'
import router from './router'
import i18n from './i18n/config'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import interceptors from './services/Interceptor'
import vuetify, { vPhoneInput } from '@/plugins/vuetify/config'
import store from './store/index'
import Vuex from 'vuex'
import * as Sentry from '@sentry/vue'

const app = createApp(App)

if (
  import.meta.env.VITE_DSN_SENTRY &&
  import.meta.env.VITE_TRACES_SAMPLE_RATE &&
  import.meta.env.VITE_REPLAYS_SESSION_SAMPLE_RATE &&
  import.meta.env.VITE_REPLAYS_ON_ERROR_SAMPLE_RATE
) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_DSN_SENTRY,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: import.meta.env.VITE_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate: import.meta.env.VITE_REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: import.meta.env.VITE_REPLAYS_ON_ERROR_SAMPLE_RATE
  })
}

interceptors(store)

app.use(router)
app.use(vPhoneInput)
app.use(vuetify)
app.use(store)
app.use(Vuex)
app.use(i18n)
app.use(Sentry)
app.use(VueReCaptcha, { siteKey: import.meta.env.VITE_CAPTCHA })

app.mount('#app')
